export default function functionOrFalse(props, propName) {
    if (props[propName] === false || typeof props[propName] === 'function') {
        return
    } else {
        return new Error(`Prop ${propName} expected to be a function, or false`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/app/functionOrFalse.js